import type { FC } from "react";
import { useState } from "react";

import type { IconName } from "@similarweb/icons";
import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import GrandAccessBanner from "app/pages/sales-intelligence/common-components/GrandAccessBanner/GrandAccessBanner";
import { resolveSignalsApiCustomAttributes } from "app/pages/sales-intelligence/modules/management/services/tracking/utils";
import { useSignalsApiStatusPollingQuery } from "app/pages/sales-intelligence/modules/management/sub-modules/signals-api/query/queries/useSignalsApiStatusPollingQuery";
import { requestIntentDataAccess } from "app/pages/sales-intelligence/modules/signals/services/requestSignalTypeAccess";
import { SuccessBannerContent } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/IntentDataBanner/SuccessBannerContent";

interface IIntentDataBanner {
    title: string;
    description: string;
    iconImagePath: string;
    buttonText: string;
    buttonIconName: IconName;
}

export const IntentDataBanner: FC<IIntentDataBanner> = ({
    title,
    description,
    buttonText,
    buttonIconName,
    iconImagePath,
}) => {
    const [isShowSuccess, setIsShowSuccess] = useState<boolean>(false);
    const { data } = useSignalsApiStatusPollingQuery();
    return (
        <>
            {!isShowSuccess ? (
                <GrandAccessBanner
                    title={title}
                    description={description}
                    iconImagePath={iconImagePath}
                    isRounded
                    button={
                        <IconButton
                            type={"trial"}
                            onClick={() => {
                                requestIntentDataAccess(resolveSignalsApiCustomAttributes(data));
                                setIsShowSuccess(true);
                            }}
                            iconName={buttonIconName}
                        >
                            {buttonText}
                        </IconButton>
                    }
                />
            ) : (
                <SuccessBannerContent
                    title={translate("hook_modal.get_feature.success.title")}
                    subTitle={translate("si.modal.get_feature.success.subtitle.v-2")}
                />
            )}
        </>
    );
};
